import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {
  chakMarkWhite,
  deleteIconBlue,
  deleteIconCircleOrange,
  eyeClose,
  gallery1,
  gallery10,
  gallery11,
  gallery12,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  menuDotsIcon,
  modalCloseIcon,
  moveIocn,
  pinIocn,
  RestoreIcon,
} from "../../../../../images";
import Modal from "react-bootstrap/Modal";
import "./workPlacePopup.scss";
import { useWindowSize } from "react-use";
import WorkPlaceDelete from "./WorkPlaceDelete";
import BottomSheetOptions from "../GalleryEditPopups/BottomSheetOptions";
import { useBusinessContext } from "../../../../../context/BusinessAccount/BusinessAccountState";
import config from "../../../../../config/config";
import DeleteConfirmPopup from "../DeleteConfirmPopup/DeleteConfirmPopup";
import BlurGalleryImage from "../../../../../components/BlurGalleryImage/BlurGalleryImage";
import useTheme from "../../../../../components/useTheme/useTheme";
// import BottomSheetOptions from "./BottomSheetOptions";

const WorkPlaceRecentlyDeleted = forwardRef((props, ref) => {
  const { theme } = useTheme();
  const { width } = useWindowSize();
  const [columns, setColumns] = useState(4); // Default: 4 columns
  const [checkedItems, setCheckedItems] = useState({});
  const [showOptionsPopup, setShowOptionsPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showGallerypopupDeleteVariant, setShowGallerypopupDeleteVariant] =
    useState(false);
  const { data: businessData, update: updateBusinessContext } =
    useBusinessContext();
  const [arrangedImages, setArrangedImages] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const aws_object_url = config.aws_object_url;
  const baseUrl = config.api_url;
  const handleCheckboxToggle = (key, item) => {
    setSelectedImages((prev) => {
      if (checkedItems[key]) {
        return prev.filter((selected) => selected.id !== item.id);
      } else {
        return [...prev, item];
      }
    });
    setCheckedItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleDeleteImages = (data) => {
    props.onDeleteImages(data);
  };

  const handleRestoreImages = () => {
    if (selectedImages.length > 0) {
      props.onRestoreImages(selectedImages);
      setCheckedItems({});
    }
  };

  const selectedCount = Object.values(checkedItems).filter(Boolean).length;

  useEffect(() => {
    const updateColumns = () => {
      if (window.innerWidth > 1200) setColumns(4);
      else if (window.innerWidth > 1024) setColumns(4);
      else if (window.innerWidth > 768) setColumns(4);
      else if (window.innerWidth > 340) setColumns(2);
      else setColumns(2);
    };

    updateColumns();
    window.addEventListener("resize", updateColumns);
    return () => window.removeEventListener("resize", updateColumns);
  }, []);

  // Masonry logic: Arranging images row-wise instead of column-wise
  const createMasonryLayout = () => {
    const images = props?.data?.workspace_media || []; // Prefer context data

    let arranged = Array.from({ length: columns }, () => []);
    let columnHeights = Array(columns).fill(0);

    images?.forEach((img) => {
      const shortestColumnIndex = columnHeights.indexOf(
        Math.min(...columnHeights),
      );
      // arranged[shortestColumnIndex].push({
      //   src: `${aws_object_url}recently_deleted/${img?.url}`,
      //   id: img?._id,
      //   section: "workspace_media",
      //   name: img?.url,
      // });
      arranged[shortestColumnIndex].push({
        src: `${aws_object_url}recently_deleted/${img?.url}`,
        id: img?._id,
        section: "workspace_media",
        name: img?.url,
        width: img?.width,
        height: img?.height,
        blurHash: img?.blurHash,
        visibility: img?.visibility,
      });

      columnHeights[shortestColumnIndex] += 1;
    });
    setArrangedImages(arranged);
    return arranged;
  };

  const [isHovered, setIsHovered] = useState(false);
  const menuRef = useRef(null);
  const handleShowDeletePopupClose = () => setShowDeletePopup(false);
  const handleShowDeletePopupOpen = () => setShowDeletePopup(true);
  const handleGallerypopupDeleteVariantOpen = () =>
    setShowGallerypopupDeleteVariant(true);
  const handleGallerypopupDeleteVariantClose = () =>
    setShowGallerypopupDeleteVariant(false);
  const handleOptionsPopupOpen = () => setShowOptionsPopup(true);
  const handleOptionsPopupClose = () => setShowOptionsPopup(false);

  useImperativeHandle(ref, () => ({
    handleShowDeletePopupClose,
    resetCheckedItems: () => {
      setSelectedImages([]);
      setCheckedItems({});
    },
  }));

  useEffect(() => {
    createMasonryLayout();
  }, [businessData, props?.data, columns]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsHovered(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {width <= 768 && (
        <BottomSheetOptions
          show={showOptionsPopup}
          handleClose={handleOptionsPopupClose}
          handelOpenDelete={() => {}}
          handelOpenRecentlyDeleted={() => {}}
          workplaceBottomSheet={true}
        />
      )}
      <DeleteConfirmPopup
        theme={theme}
        show={showDeletePopup}
        handleClose={handleShowDeletePopupClose}
        // headingSugested={"Add More Project Photos & Renders"}
        data={selectedImages}
        deleteImages={handleDeleteImages}
        action={"permanent"}
      />
      <Modal
        {...props}
        centered
        className={`Gallery_popup_modal gallery_popup_edit ${
          theme === "dark" && "nw_gl_popup--dark-mode"
        }`}
        backdropClassName="custom-backdrop-gallery-edit"
        fullscreen={true}
      >
        {/* <Modal.Header closeButton></Modal.Header> */}
        <Modal.Header>
          <button
            className="custom-cancel-btn"
            onClick={() => {
              setCheckedItems({});
              setSelectedImages([]);
              props.handleCloseDelete();
            }}
          >
            <img
              src={modalCloseIcon}
              alt="close-icon"
              className="ctm_img_bussine_edit_about"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <h2 className="Gallery_popup_heading d-flex align-items-center">
            Recently Deleted
            <div
              className="menu-wrapper"
              ref={menuRef}
              onClick={
                width <= 768
                  ? handleOptionsPopupOpen
                  : () => setIsHovered(!isHovered)
              }
            ></div>
          </h2>

          <h3 className="popup_muted_title fst-italic">
            Deleted images are saved in “Recently Deleted” but excluded from AI
            matchmaking.
          </h3>
          <h3 className="popup_muted_title pb-2">
            {selectedCount} images selected
          </h3>
          <div className="masonry-gallery-two">
            {arrangedImages.map((column, colIndex) => (
              <div className="masonry-column" key={colIndex}>
                {column.map((item, index) => {
                  const itemKey = `${colIndex}-${index}`;
                  const isChecked = checkedItems[itemKey];

                  return (
                    <div
                      className="masonry-item position-relative"
                      key={itemKey}
                    >
                      {/* <div
                        className="img-skeleton-bg"
                        style={{
                          aspectRatio: "auto",
                        }}
                      >
                        <img
                          src={item?.src}
                          alt={`Gallery ${index}`}
                          loading="lazy"
                          decoding="async"
                          onLoad={(e) => {
                            // Set parent height based on loaded image
                            const imgHeight = e.target.offsetHeight;
                            e.target.parentElement.style.minHeight = `${imgHeight}px`;
                          }}
                        />
                      </div> */}

                      <BlurGalleryImage
                        item={{
                          src: item.src,
                          width: item.width,
                          height: item.height,
                          blurHash: item.blurHash,
                          visibility: item.visibility,
                        }}
                      />

                      <div
                        onClick={() => handleCheckboxToggle(itemKey, item)}
                        className={`${
                          isChecked
                            ? "checked check_box_ctm_popup_wraper"
                            : "check_box_ctm_popup_wraper"
                        }`}
                      >
                        {/* Hidden input just to keep HTML semantics */}
                        <input
                          type="checkbox"
                          checked={isChecked || false}
                          onChange={() => {}}
                          className="hiden_ip_ctm_popup"
                        />

                        {isChecked && (
                          <img
                            src={chakMarkWhite}
                            alt="Checkmark"
                            className="chek_mark_ctm_popup"
                          />
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>

          {selectedCount > 0 && (
            <div className="delete_gallery_image d-flex">
              <div
                className="delete_wrapper resotre_warperr"
                onClick={handleRestoreImages}
              >
                <img src={RestoreIcon} alt="delete" className="delete_icon" />
                Restore
              </div>
              <div
                className="delete_wrapper me-0"
                onClick={handleShowDeletePopupOpen}
              >
                <img
                  src={deleteIconBlue}
                  alt="delete"
                  className="delete_icon"
                />
                Permanently Delete
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
});

export default WorkPlaceRecentlyDeleted;
